<template>
  <slot v-if="isAdmin"></slot>
  <template v-else>
    <div @click="handleClick">
      <slot name="btn">
        <!-- default button, overriden by anything passed into #btn slot -->
        <v-btn
          :color="color"
          :variant="variant as any"
          :text="label"
          :prepend-icon="prependIcon"
          :disabled="disabled"
        >
          {{ label }}
        </v-btn>
      </slot>
    </div>

    <AdminOverrideDialog
      v-model="showAdminOverride"
      :overrideAction="handleClick"
      :closeDialog="closeAdminOverride"
    />
  </template>
</template>

<script lang="ts" setup>
import { useAuthStore } from "@/stores/auth";
import { ref } from "vue";

const showAdminOverride = ref(false);
const authStore = useAuthStore();

const props = withDefaults(
  defineProps<{
    color?: string;
    variant?: string;
    label?: string;
    prependIcon?: string;
    disabled?: boolean;
    onClick?: () => void | undefined;
  }>(),
  {
    disabled: false,
  },
);

const { color, variant, label, prependIcon, onClick } = props;

const handleClick = () => {
  const permitted = checkAdminPermissions();
  if (permitted) {
    if (onclick && typeof onClick === "function") {
      onClick();
    }
  } else {
    showAdminOverride.value = true;
  }
};

const checkAdminPermissions = () => {
  if (authStore.isAuthenticated()) {
    const userPermissions = authStore.permissions;

    if (authStore.hasPermission("admin", "ADMIN")) {
      showAdminOverride.value = false;
      return true;
    } else {
      showAdminOverride.value = true;
    }
  }
  return false;
};

const isAdmin = computed(() => {
  return (
    authStore.isAuthenticated() && authStore.hasPermission("admin", "ADMIN")
  );
});

function setAdminOverride() {
  showAdminOverride.value = true;
}

function closeAdminOverride() {
  showAdminOverride.value = false;
}
</script>
